import { useMutation, useQueries, useQueryClient } from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { fetchExpenseType } from "./provisionItem";
import { fetchSalaryWorkers } from "./salaryWorkers";

const fetchExpenses = async (year: any, companyId: any) => {
  return await axios({
    method: "get",
    url: SERVICES.EXPENSES,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
    },
  }).then((res) => res.data || []);
};

const fetchCompanies = async () => {
  return await axios({
    method: "get",
    url: SERVICES.COMPANIES,
    params: {
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      scope: "list_all",
    },
  }).then((res) => res.data || []);
};

export const usePromiseSettledExpenses = (year: any) => {
  const companyId = getCompanyId();
  const queryConfig = {
    staleTime: 300,
    cacheTime: 300,
    // retry: 1,
    enabled: !!year,
  };

  return useQueries({
    queries: [
      {
        queryKey: ["QUERY_NAME.EXPENSES", 1, year, companyId],
        queryFn: () => fetchExpenses(year, companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.EXPENSES", 2, year, companyId],
        queryFn: () => fetchSalaryWorkers(companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.EXPENSES", 3, year, companyId],
        queryFn: () => fetchCompanies(),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.EXPENSES", 4, companyId],
        queryFn: () => fetchExpenseType(companyId),
        ...queryConfig,
      },
    ],
  });
};

export const useSubmitExpenses = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();

  return useMutation(
    ({ payload }: any) =>
      axios({
        method: "post",
        url: SERVICES.EXPENSES_SAVE,
        data: payload,
        params: {
          company_id: companyId,
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.EXPENSES]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
